"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FalconMultipleCheckboxWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var react_html_parser_1 = require("react-html-parser");
var Types_1 = require("../Types");
var core_1 = require("@athena-portal/core");
var FalconMultipleCheckboxWidget = /** @class */ (function (_super) {
    __extends(FalconMultipleCheckboxWidget, _super);
    function FalconMultipleCheckboxWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.checkboxLabels = _this.getSetting("checkboxLabels", undefined);
        _this.handleChange = function (event) {
            var allChecked = _this.state.allChecked;
            var oneChecked = allChecked.get(event.target.name);
            allChecked.delete(event.target.name);
            allChecked.set(event.target.name, !oneChecked);
            _this.setState({ allChecked: allChecked });
            if (Array.from(_this.state.allChecked.values()).includes(false)) {
                _this.props.onStateChange(_this.props.question.interactionField, false);
            }
            else {
                _this.props.onStateChange(_this.props.question.interactionField, true);
            }
            _this.changelogRecorder.recordQuestion("change", _this.props);
        };
        var allChecked = new Map();
        if (_this.checkboxLabels) {
            _this.checkboxLabels.forEach(function (element, index) {
                _this.bindFromField(_this.props.question.interactionField)
                    ? allChecked.set("checkbox-".concat(index), true)
                    : allChecked.set("checkbox-".concat(index), false);
            });
        }
        else {
            throw Error("".concat(_this.props.question.type, " widget missing 'checkboxLabels' setting"));
        }
        _this.state = {
            allChecked: allChecked
        };
        return _this;
    }
    FalconMultipleCheckboxWidget.prototype.render = function () {
        var _this = this;
        return ((0, jsx_runtime_1.jsx)(React.Fragment, { children: (0, jsx_runtime_1.jsxs)("div", { className: "falcon-checkbox form-group ".concat(this.getSetting("cssClass", "")), children: __spreadArray([this.props.question.label && (0, jsx_runtime_1.jsx)("label", { className: "fs-18", children: this.props.question.label })], this.checkboxLabels.map(function (checkboxLabel, index) { return ((0, jsx_runtime_1.jsx)("div", { className: "d-flex", children: (0, jsx_runtime_1.jsxs)("div", { className: "form-check mr-3", children: [(0, jsx_runtime_1.jsx)("input", { className: "custom-control-input ".concat(_this.state.allChecked.get("checkbox-".concat(index))), type: "checkbox", "aria-label": _this.getSetting("ariaLabel", ""), onChange: _this.handleChange, name: "checkbox-".concat(index), id: "checkbox-".concat(index), checked: _this.state.allChecked.get("checkbox-".concat(index)) }), (0, jsx_runtime_1.jsxs)("label", { className: "custom-control-label", htmlFor: "checkbox-".concat(index), children: [(0, jsx_runtime_1.jsx)("div", { className: "checkbox-big" }), (0, jsx_runtime_1.jsx)("div", { className: "checkbox-label", children: (0, jsx_runtime_1.jsx)("p", { children: (0, react_html_parser_1.default)(checkboxLabel) }) })] })] }) }, index)); }), true) }) }));
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.ChangelogRecorder),
        __metadata("design:type", Object)
    ], FalconMultipleCheckboxWidget.prototype, "changelogRecorder", void 0);
    return FalconMultipleCheckboxWidget;
}(plugin_journey_1.WidgetBase));
exports.FalconMultipleCheckboxWidget = FalconMultipleCheckboxWidget;
//# sourceMappingURL=FalconMultipleCheckboxWidget.js.map